import { render, staticRenderFns } from "./workWithTubber.vue?vue&type=template&id=f5100570&scoped=true"
import script from "./workWithTubber.vue?vue&type=script&lang=js"
export * from "./workWithTubber.vue?vue&type=script&lang=js"
import style0 from "./workWithTubber.vue?vue&type=style&index=0&id=f5100570&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5100570",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default})
